
import store from '../../store';
import Vue from 'vue';

const success = (data, resolve) => {
  const bestClientsWidgetsData = data;
  store.dispatch('fetchBestClientsDataWidgets', bestClientsWidgetsData);
  resolve();
};

const failed = (error, reject) => reject(error);

export default (filter = 'last_3_months') => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`user-widgets/best-clients/${filter}`)
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/widgets/fetchBestClientsWidgets.js